import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from '../../../../three-dots-menu.module.scss';

type ThreeDotsMenuItemTextProps = {
    className?: string;
};
export const ThreeDotsMenuItemText = ({
    children,
    className,
}: PropsWithChildren<ThreeDotsMenuItemTextProps>) => {
    return <div className={classNames(styles.menuItemText, className)}>{children}</div>;
};
